import React from "react"

export default function Home() {
  return <h1>Prima build automatica</h1>
}
